export const state = () => ({
  stats: null,
})

export const mutations = {
  /**
   * Set the performance dashboard payload.
   * @param {Object} state - Vuex state
   * @param {Object} stats - Performance payload returned by /admin/tryOn/performance/stats
   */
  setStats(state, stats) {
    state.stats = stats
  },
}

export const getters = {
  /**
   * Get the cached performance payload.
   * @param {Object} state - Vuex state
   * @returns {Object|null} Stats payload
   */
  getStats(state) {
    return state.stats
  },
}

export const actions = {
  /**
   * Fetch the Try-On performance dashboard payload.
   * @param {Object} context - Vuex context
   * @param {Object} params - { from, to }
   * @returns {Promise} API response
   */
  async fetchStats({ commit }, params = {}) {
    const response = await this.$axios.$get('admin/tryOn/performance/stats', { params })
    if (response) {
      commit('setStats', response)
    }
    return response
  },

  /**
   * Stream the by-product CSV export for the active filter window.
   * @param {Object} context - Vuex context
   * @param {Object} params - { from, to }
   * @returns {Promise<Blob>} CSV blob
   */
  async exportCsv(_context, params = {}) {
    const response = await this.$axios.get('admin/tryOn/performance/export', {
      params,
      responseType: 'blob',
    })
    return response.data
  },
}
